import React, {Component} from "react";
import styles from "./RadioButton.module.css";
import {withTranslation} from "react-i18next";

class RadioButton extends Component {

    state = {
        id: this.props.id,
        name: this.props.name,
        label: this.props.label,
        value: this.props.value,
        checked: this.props.checked,
        smallLabel: this.props.smallLabel
    };

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        let id = this.props.id ? this.props.id : ""
        let disabled = this.props.disabled ? this.props.disabled : false
        document.getElementById(id).disabled = disabled;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.checked !== this.props.checked) {
          this.setState({checked: this.props.checked});
        }
        let id = this.props.id ? this.props.id : ""
        let disabled = this.props.disabled ? this.props.disabled : false
        if (document.getElementById(id))
            document.getElementById(id).disabled = disabled;
    }

    handleOnClick(event) {
        this.setState({checked: event.target.checked})
        if (this.props.onClick && event.target.checked && this.props.newRadio) {
            this.props.onClick(this.state.name, event)
        } else if (this.props.onClick && event.target.checked) {
            this.props.onClick(event.target.value)
        }
    }

    render() {

        const {t} = this.props

        let inputCssClass = "with-gap"; //css di default

        if (this.props.customClasses && this.props.customClasses.length > 0) {
            inputCssClass = this.props.classes.join(" ")
        }
        const inputElement = (
            <div className="form-check">
                <input name={this.state.name} type="radio"
                       className={`inputCssClass ${this.props.isYellow ? 'yellowRadio' : this.props.border ? 'borderYellowRadio' : ''}`}
                       onClick={(e) => {
                           this.handleOnClick(e)
                       }}
                       checked={this.state.checked}
                       value={this.state.value} id={this.state.id} />
                <label htmlFor={this.state.id ? this.state.id : "radio1"}
                       style={this.props.style ? this.props.style :
                           {color: "#1b7ea9", fontSize: this.state.smallLabel ? "14px" : ""}}
                        className={`${this.state.checked && this.props.sottolineaSelected ? styles.sottolineato : ''}`}
                >{this.state.label ? this.state.label : ""}</label><br/>
                {this.props.required ?
                    <label htmlFor={this.state.id ? this.state.id : "radio1"}
                           style={{color: "black", fontSize: "14px"}}
                    >{t("Utils.opzione")}<span className={styles.mandatoryColor}>*</span>
                    </label> : ""}
            </div>
        );
        return inputElement;
    }
}

export default withTranslation('common')(RadioButton)
